/* eslint-disable react/react-in-jsx-scope */

import '../css/Footer.css';
// import ThemeSelector from './ThemeSelector';

function Footer() {
  return (
    <footer>
      <div className='footer-content'>
      <p className='footer-developedby'>Developed by Koen Hankel</p>
      </div>
    </footer>
  );
}

export default Footer;